import * as React from "react";

import { AppWrapper, InfoCard } from '@eto/eto-ui-components';
import { css } from "@emotion/react";

import OpenGraphMeta from "@components/OpenGraphMeta";
import DonationContent from "@content/general/donate.mdx";

const infoCardStyles = css`
  .alert,
  .eto-subscribebox {
    margin: 1rem auto;
  }
`;

const DonatePage = () => {
  return (
    <AppWrapper fromPlatform={true}>
      <InfoCard
        css={infoCardStyles}
        title="Donate"
      >
        <DonationContent />
      </InfoCard>
    </AppWrapper>
  )
}

export default DonatePage

export function Head() {
  return <OpenGraphMeta
    slug="/donate/"
    title="Donate &ndash; Emerging Technology Observatory"
  />
}
